/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../components/UI'
import {FC, useEffect, useState} from 'react'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {DocumentModel, DocumentPersonModel} from '../../../../model'
import {getDocumentByPerson} from '../../../../services'
import {deleteDocumentByPerson, updateDefaultDocumentByPerson} from '../../../../services'
import {useCentral} from '../../../../../../hooks/useCentral'
import {AddDocuments} from '../Modal/ModalAddDocuments'
import Swal from 'sweetalert2'
import {ShowSnackBar, confirmModal} from '../../../../../../util/functions'
import {SUCCESS_MESSAGE_DELETE} from '../../../../../../util/Constants'
import {TabCentralModel} from '../../../../../../models'
const TableDocument: FC = () => {
  const {data, setData, setPagination, loading, setLoading, clearSelected, selectedOn, pagination} =
    useKTable()
  const {currentTabItem, isAllowed, changeCurrentTabItem} = useCentral()
  const [showModalNew, setShowModalNew] = useState(false)
  const [idPermission, setIdPermission] = useState<any>('')
  const [detailpermission, setDetailPermission] = useState<DocumentPersonModel | {}>({})

  const handleClear = () => {
    setIdPermission('')
  }
  const getDocumentByPersonList = async () => {
    try {
      clearSelected()
      setLoading(true)
      const {data: response} = await getDocumentByPerson(
        pagination.currentPage,
        currentTabItem.idToEdit,
      )
      if (!response.error) {
        const NewData = response.data.map((item) => {
          item.checkDefault = item.docDefault === 'NO' ? false : true
          item.isActive = item.estado === 'ACT' ? false : true
          return item
        })
        setData(NewData)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const handleEdit = (item: DocumentPersonModel) => {
    const filter = data.filter((detail) => detail.id === item.id)
    setDetailPermission({documento: filter[0]})
    setIdPermission(item.id)
    setShowModalNew(true)
  }

  const handleActiveDefault = async (item: DocumentPersonModel) => {
    const filter = data.filter((detail) => detail.id === item.id)
    const text = `Estás activando como principal: <br>
    Tipo de documento: ${filter[0]?.tipoDocumento}  <br>
    Número de documento: ${filter[0]?.numeroDocumento}`
    Swal.fire({
      title: '¿Estás seguro?',
      html: text,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si',
      confirmButtonColor: 'var(--kt-primary)',
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      if (result.isConfirmed) {
        const {data: response} = await updateDefaultDocumentByPerson(item.id)
        if (!response.error) {
          getDocumentByPersonList()
        } else {
        }
        getDocumentByPersonList()
        Swal.close()
      } else if (result.isDenied) {
      }
    })
  }
  useEffect(() => {
    getDocumentByPersonList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage, currentTabItem.idToEdit])

  const columns: Column<DocumentModel>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} />,
      id: 'selection',
      Cell: ({...props}) => <KTableSelectionCellNonMultiple id={props.data[props.row.index].id} />,
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo de documento' />,
      accessor: 'nombreTipoDocumento',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Número de documento' />,
      accessor: 'numeroDocumento',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Estado' />,
      accessor: 'nombreEstado',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Documento principal' />,
      id: 'actions1',
      Cell: ({...props}) => (
        <div className='d-flex justify-content-center flex-shrink-0'>
          <div className='sdx_form_input '>
            <div className='form-check form-switch'>
              <input
                className='form-check-input'
                type='checkbox'
                role='switch'
                disabled={props.data[props.row.index].isActive}
                checked={props.data[props.row.index].checkDefault}
                onChange={() => handleActiveDefault(props.data[props.row.index])}
              />
            </div>
          </div>
        </div>
      ),
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
      id: 'actions',
      Cell: ({...props}) => (
        <>
          {isAllowed('IDENTIFICACION/EDITAR') && (
            <div
              className='d-flex justify-content-center flex-shrink-0'
              onClick={() => handleEdit(props.data[props.row.index])}
            >
              <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
              </a>
            </div>
          )}
        </>
      ),
    },
  ]

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  useEffect(() => {
    if (currentTabItem.fromCreateButton && data.length > 0) {
      const document = data[0]
      setDetailPermission({documento: document})
      setIdPermission(document.id)
      setShowModalNew(true)
      const obj: TabCentralModel = {
        ...currentTabItem,
        fromCreateButton: false,
      }
      changeCurrentTabItem(obj)
    }
  }, [currentTabItem.fromCreateButton, data])

  const handleDelete = async () => {
    let title = '¿Estás seguro?'
    let bodyText = 'Al eliminar no podrás revertir esta acción'
    let textButtonCancel = 'No'
    let textButtonConfirm = 'Si, eliminar'
    const result = await confirmModal({
      title,
      bodyText,
      icon: 'warning',
      textButtonCancel,
      textButtonConfirm,
    })
    if (!result.isConfirmed) return
    const {data: response} = await deleteDocumentByPerson(selectedOn[0])
    if (!response.error) {
      ShowSnackBar(SUCCESS_MESSAGE_DELETE)
    } else {
      ShowSnackBar(response.message, 'error')
    }
    getDocumentByPersonList()
    // Swal.close()
  }

  const handleNew = () => {
    setShowModalNew(true)
  }

  return (
    <>
      {isAllowed('IDENTIFICACION/LISTAR') && (
        <KTCard shadow className='m-5'>
          <div className='d-flex justify-content-end p-2 me-5'>
            {isAllowed('IDENTIFICACION/AGREGAR') && (
              <button type='button' className='btn btn-success me-3' onClick={handleNew}>
                Agregar
              </button>
            )}
            {isAllowed('IDENTIFICACION/ELIMINAR') && (
              <button
                type='button'
                className='btn btn-primary me-3'
                disabled={selectedOn.length < 1}
                onClick={handleDelete}
              >
                Eliminar
              </button>
            )}
          </div>
          <KTable data={data} columns={columns} />
          {loading ? <KTableLoading title='Cargando...' /> : null}
          {showModalNew ? (
            <AddDocuments
              show={showModalNew}
              setShow={setShowModalNew}
              getDocumentPersonList={getDocumentByPersonList}
              detailpermission={detailpermission}
              idPermission={idPermission}
              setIdPermissionList={handleClear}
            />
          ) : (
            <></>
          )}
        </KTCard>
      )}
    </>
  )
}

const TableDocumentWrapper = () => {
  return (
    <KTableProvider>
      <TableDocument />
    </KTableProvider>
  )
}
export {TableDocumentWrapper}
